import * as React from "react";
import { ThemeType } from "shared/styles/theme";
import styled, { css, keyframes } from "styled-components";
import theme from "styled-theming";
import colors from "../styles/colors";

const bounceInUp = keyframes`
    from,
    60%,
    75%,
    90%,
    to {
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    from {
        opacity: 0;
        transform: translate3d(-50%, 3000px, 0) scaleY(5);
    }

    60% {
        opacity: 1;
        transform: translate3d(-50%, -20px, 0) scaleY(0.9);
    }

    75% {
        transform: translate3d(-50%, 10px, 0) scaleY(0.95);
    }

    90% {
        transform: translate3d(-50%, -5px, 0) scaleY(0.985);
    }

    to {
        transform: translate3d(-50%, 0, 0);
    }
`

const bottomBarBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.purpleBackground,
    [ThemeType.dark]: colors.dark2
})

const bottomBarBorderTopColor = theme("mode", {
    [ThemeType.light]: colors.purplePrimary,
    [ThemeType.dark]: colors.grey_1
})

export const StyledBottomBar = styled.div<BottomBarProps>`
    display: flex;
    position: fixed;
    width: 100%;
    bottom: 0px;
    height: 50px;
    left: 50%;
    transform: translate(-50%, 0);
    background-color: ${bottomBarBackgroundColor};
    border-top: 2px solid ${bottomBarBorderTopColor};
    z-index: 99;
    transition: opacity .4s, transform .4s;

    ${props => props.isShown ? css`
        animation: ${bounceInUp} 0.8s;
    ` : css`
        pointer-events: none;
        opacity: 0;
    `}

    align-content: center;
    justify-content: center;
    align-items: center;

    .input-group {
        margin-top: 7px;
        margin-bottom: 8px;
        margin-left: auto;
        margin-right: auto;
        padding: 0 10px;
        max-width: 800px;
        width: 100%;
    }

    .btn-group {
        margin-left: 10px;
    }

    .btn.save-button {
        width: auto;
        border-radius: 0;
    }

    .dropdown-menu {
        cursor: pointer;
    }

`

export const BottomBar: React.FC<React.PropsWithChildren<BottomBarProps>> = (props) => {
    return (
        <StyledBottomBar isShown={props.isShown} id="save-changes-bar">
            {props.isShown ? props.children : null}
        </StyledBottomBar>
    );
};

interface BottomBarProps {
    isShown: boolean;
}
